﻿import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "@/features/axiosHelper";
import { useState } from "react";

export const fileTypesEnum = {
  csv: 0,
  excel: 1,
};

export const importDataTypesEnum = {
  Catalog_CustomerAndShipTo: 0,
  Catalog_ItemAndUOM: 1,
  Catalog_Carrier: 2,
  Catalog_Warehouse: 3,
  Catalog_MiscAC: 4,
  CrossReference_CustomerAndShipTo: 100,
  CrossReference_ItemAndUOM: 101,
  CrossReference_Carrier: 102,
  CrossReference_Warehouse: 103,
  CrossReference_MiscAC: 104,
  File_Inbound: 200,
  WorkflowLookup_ThreePLQualifer: 300,
  WorkflowLookup_DefaultWarehouse: 301,
  WorkflowLookup_ImpliedDC: 302,
};

export const importTabTypesEnum = {
  catalog: 0,
  crossReference: 1,
  fileManager: 2,
  workflowLookup: 3,
};

export const importStatusEnum = {
  Queued: 0,
  Processing: 10,
  Completed: 20,
  CompletedWithWarning: 21,
  Failed: 22,
  Cancelled: 30,
};

const fileImportSlice = createSlice({
  name: "fileImport",
  initialState: {
    fileImportPopupOpen: false,
    fileOptions: [],
    selectedDataType: -1,
    tabType: null,
    tabDataType: null,
    loadingError: "",
  },
  reducers: {
    setFileImportPopupOpen: (state, action) => {
      const { open, tabType, dataType } = action.payload;

      state.fileImportPopupOpen = open;
      state.tabType = tabType;
      state.tabDataType = dataType;
    },
    setSelectedDataType: (state, action) => {
      const { value } = action.payload;
      state.selectedDataType = value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFileImportDataTypes.pending, (state, action) => {
        //state.catalogSummary.recordsLoaded = false;
      })
      .addCase(fetchFileImportDataTypes.rejected, (state, action) => {
        state.loadingError = action.error.message;
      })
      .addCase(fetchFileImportDataTypes.fulfilled, (state, action) => {
        const { options, selectedOption } = action.payload.data;
        state.fileOptions = options;
        state.selectedDataType = selectedOption;
      });
  },
});

export const fetchFileImportDataTypes = createAsyncThunk(
  "fileImport/fetchFileImportDataTypes",
  async (_, { getState }) => {
    const state = getState();
    const response = await axios.get("/fileimport/sub-data-types", {
      params: {
        tabType: state.tempInfo.fileImport.tabType,
        subTabSelected: state.tempInfo.fileImport.tabDataType,
      },
    });
    return response;
  }
);

export const fetchRecentImportFileLogs = createAsyncThunk(
  "fileImport/fetchRecentImportFileLogs",
  async () => {
    const response = await axios.get("/fileImport/logs");
    return response;
  }
);

export const { setFileImportPopupOpen, setSelectedDataType } =
  fileImportSlice.actions;
export const selectFileImportPopupOpen = (state) =>
  state.tempInfo.fileImport.fileImportPopupOpen;
export const selectFileImportOptions = (state) =>
  state.tempInfo.fileImport.fileOptions;
export const getSelectedDataType = (state) =>
  state.tempInfo.fileImport.selectedDataType;
export const getTabType = (state) => state.tempInfo.fileImport.tabType;

export default fileImportSlice.reducer;
